// extracted by mini-css-extract-plugin
module.exports = {"sl0r50n":"sl0r50n"};